import React from 'react';
import PropTypes from 'prop-types';
import { Table, useFetch, PseudoStates } from '@cordata/buffet';
import { format } from 'date-fns';

const columns = [{
  id: 'orgName',
  Header: 'Organization',
  accessor: 'attributes.orgName',
}, {
  id: 'divisionName',
  Header: 'Division',
  accessor: 'attributes.divisionName',
}, {
  id: 'dataType',
  Header: 'Data Type',
  accessor: 'attributes.dataType',
}, {
  id: 'status',
  Header: 'Status',
  accessor: 'attributes.status',
}, {
  id: 'rowDetail',
  Header: 'Row Details',
  accessor: i => i,
  filterable: false,
  sortable: false,
  Cell: c => (
    <>
      <strong><span className="text-success">{c.value.attributes.importedRows}</span></strong>
      <span className="text-muted"> / </span>
      <strong><span className="text-danger">{c.value.attributes.rowsWithErrors}</span></strong>
      <span className="text-muted"> / </span>
      <strong><span className="text-primary">{c.value.attributes.totalRows}</span></strong>
    </>
  ),
}, {
  id: 'createdDate',
  Header: 'Created Date',
  accessor: 'attributes.createdDate',
  Cell: c => c.value && format(c.value, 'ddd MMM Do YYYY [@] h:mm A'),
}, {
  id: 'completedDate',
  Header: 'Completed Date',
  accessor: 'attributes.completedDate',
  Cell: c => c.value && format(c.value, 'ddd MMM Do YYYY [@] h:mm A'),
}];

const BatchImportCollection = ({ onClick }) => {
  const [status, data] = useFetch('admin/batch-imports');

  return status === 'success'
    ? (
      <>
        <Table
          filterable
          loading={status === 'loading'}
          columns={columns}
          data={data}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) =>
              onClick(e, handleOriginal, rowInfo),
          })}
        />

        <p className="text-center text-muted mt-2">
          <small>
            <em>Row details legend:{' '}</em>
            <span className="text-success" pill>Imported Rows</span>{' / '}
            <span className="text-danger" pill>Failed Rows</span>{' / '}
            <span className="text-primary" pill>Total Rows</span>
          </small>
        </p>
      </>
    ) : (
      <PseudoStates status={status} />
    );
};

BatchImportCollection.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BatchImportCollection;
